import flights from './flights/creations'
import cars from './cars/creations'
import hotels from './hotels/creations'

export default [
  ...flights,
  ...cars,
  ...hotels,
]
